import SalesInvoiceFormat1 from './templates/SalesInvoiceFormat1';
import SalesInvoiceFormat2 from './templates/SalesInvoiceFormat2';
import SalesInvoiceFormat3 from './templates/SalesInvoiceFormat3';
import SalesInvoiceFormat4 from './templates/SalesInvoiceFormat4';
import SalesInvoiceFormat5 from './templates/SalesInvoiceFormat5';
import SalesInvoiceFormat6 from './templates/SalesInvoiceFormat6';
import SalesInvoiceFormat7 from './templates/SalesInvoiceFormat7';
import SalesInvoiceFormat8 from './templates/SalesInvoiceFormat8';

export const invoiceTemplates = {
  format1: {
    id: 'format1',
    name: 'Format 1',
    component: SalesInvoiceFormat1,
    thumbnail: '/images/formats/format1.png'
  },
  format2: {
    id: 'format2',
    name: 'Format 2',
    component: SalesInvoiceFormat2,
    thumbnail: '/images/formats/format2.png'
  },
  format3: {
    id: 'format3',
    name: 'Format 3',
    component: SalesInvoiceFormat3,
    thumbnail: '/images/formats/format3.png'
  },
  format4: {
    id: 'format4',
    name: 'Format 4',
    component: SalesInvoiceFormat4,
    thumbnail: '/images/formats/format4.png'
  },
  format5: {
    id: 'format5',
    name: 'Format 5',
    component: SalesInvoiceFormat5,
    thumbnail: '/images/formats/format5.png'
  },
  format6: {
    id: 'format6',
    name: 'Format 6',
    component: SalesInvoiceFormat6,
    thumbnail: '/images/formats/format6.png'
  },
  format7: {
    id: 'format7',
    name: 'Format 7',
    component: SalesInvoiceFormat7,
    thumbnail: '/images/formats/format7.png'
  },
  format8: {
    id: 'format8',
    name: 'Format 8',
    component: SalesInvoiceFormat8,
    thumbnail: '/images/formats/format8.png'
  }
};

export default invoiceTemplates;
